import KnowHowList from 'components/KnowHowList';
import Layout from 'components/Layout';
import SEO from 'components/seo';
import React, { useEffect, useState } from "react";
import { owned_media_list } from "src/constants";
import Style from "styles/components/owned_media.module.scss";
import PageNation from 'components/PageNation';
import { useLocation } from "@reach/router";

const ITEMS_PER_PAGE = 10;

const fetchMedia = async () => {
  try {
    const response = await fetch(owned_media_list, { cache: "no-store" });
    if (!response.ok) {
      throw new Error("メディアデータの取得に失敗しました");
    }
    return await response.json();
  } catch (error) {
    console.error("fetchMedia エラー:", error);
    return [];
  }
};

export const useMedia = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const loadMedia = async () => {
      const json = await fetchMedia();
      if (!json) return setItems([]);

      setItems(json);
    };

    loadMedia().catch((error) => {
      console.error("メディアのロード中にエラーが発生しました:", error);
      setItems([]);
    });
  }, []);
  return items;
};

const ComachiPage = () => {
  const items = useMedia();
  
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = Number(queryParams.get("page"));
  const currentPage = isNaN(page) || page < 1 ? 1 : page;
    
  const totalPages = Math.ceil(items.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentKnowHowList = items.slice(startIndex, startIndex + ITEMS_PER_PAGE);
    
  return (
    <Layout>
      <SEO title='comachicart' path='know_how' />
      <KnowHowList items={currentKnowHowList}/>
      <div className={Style.pagenation}>
          <PageNation
             page="/know_how"
             currentPage={currentPage}
             totalPages={totalPages}
          />
      </div>
    </Layout>
  );
};

export default ComachiPage;
